import { Component, OnInit } from '@angular/core';
import { timer } from 'rxjs';

@Component({
  selector: 'app-end',
  templateUrl: './end.component.html',
  styleUrl: './end.component.css'
})
export class EndComponent implements OnInit {
  loading: boolean = true;


  ngOnInit(): void {
    timer(10000).subscribe(() => {
      this.loading = false;
    });
  }

  closePage(): void {
    window.close(); // Close the current tab or window
  }
}
